import { render, staticRenderFns } from "./FrontJacketList.vue?vue&type=template&id=0b0ad956&"
import script from "./FrontJacketList.vue?vue&type=script&lang=js&"
export * from "./FrontJacketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports